module.exports = __webpack_public_path__ + "img/cirujia-jf.5c583e58.png";